import { SVGProps } from "react";

const ComingSoonSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.649 19.8981L19.8972 11.6481C20.2556 11.2897 20.2556 10.7085 19.8972 10.3492L11.649 2.09917C11.2924 1.74167 10.7076 1.74167 10.351 2.09917L2.10283 10.3492C1.74442 10.7076 1.74442 11.2888 2.10283 11.6481L10.351 19.8981C10.7076 20.2547 11.2924 20.2547 11.649 19.8981Z"
      stroke="#2A2D31"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2099 19.7817L14.6667 11.792L11.2163 2.04142C11.1439 1.83792 10.8561 1.83792 10.7846 2.04142L7.33333 11.792L10.7901 19.7826C10.8689 19.9659 11.1311 19.9659 11.2099 19.7817Z"
      stroke="#2A2D31"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.83792 10.9743L7.82283 11.9533H14.1772L20.1621 10.9743"
      stroke="#2A2D31"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ComingSoonSvg;
